import React from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import LoginForm from "./LoginForm";
import Modal from "./Modal";

const LoginModal = ({ triggerClassName }) => {

	const [isOpenState, setIsOpenState] = useStateIfMounted(false);

	return (
		<Modal
			title="Acceso clientes"
			isOpen={ isOpenState }
			setModalIsOpen={ setIsOpenState }
			triggerClassName={ triggerClassName }
		>
			<LoginForm onSuccess={ () => setIsOpenState(false) } />
		</Modal>
	);
};

export default LoginModal;
